import { useQuery } from 'react-query';
import { ParticipantsAPI } from 'api/participant';
import { PARTICIPANTS } from 'helpers/constants';

export default function useParticipants() {
  return useQuery(PARTICIPANTS, ParticipantsAPI.getAll);
}
